export default {
  Required: 'required',
  DiffierentZero: 'diffierentZero',
  Pattern: 'pattern',
  ForceSelection: 'forceSelection',
};
